import type { FileGlyphName } from '../components/FileTypeGlyph';
import type { FileKind } from './file-kind';
import type { NewDocKind } from './workspace-new-doc';

/**
 * 유형 → 그림 (2026-08-18).
 *
 * 파일 목록·필터 칩·`＋ 만들기` 메뉴가 **같은 유형에 같은 그림**을 쓰게 하는 자리다.
 * 세 곳이 각자 표를 들면 한쪽만 고쳤을 때 조용히 갈라진다 — 실제로 그전에는 필터 칩과
 * 만들기 메뉴가 "같은 그림을 쓴다" 는 약속을 주석과 테스트로만 붙들고 있었다.
 *
 * 목록(`WorkspaceFileIcon`)은 MIME 판정 결과(tone)를 열쇠로 쓰므로 이 표를 거치지 않는다.
 * 대신 이름이 같은 그림을 가리킨다 — `components/FileTypeGlyph` 의 `FileGlyphName` 하나뿐이라
 * 셋이 결국 같은 그림에 모인다.
 */

/**
 * 필터 칩의 유형 → 그림.
 *
 * `'all'`(전체)은 파일 유형이 아니라 **필터 해제**라서 그림을 주지 않는다 —
 * 없는 것이 의도이므로 `Partial` 이다.
 */
export const KIND_GLYPH: Partial<Readonly<Record<FileKind, FileGlyphName>>> = {
  word: 'word',
  excel: 'excel',
  ppt: 'ppt',
  hwp: 'hwp',
  pdf: 'pdf',
  markup: 'markup',
  txt: 'text',
  image: 'image',
  etc: 'other',
};

/**
 * `＋ 만들기` 의 새 문서 종류 → 그림.
 *
 * ⚠ `Record` 라 `NEW_DOC_KINDS` 에 종류를 더하면 **여기가 타입 에러로 막는다.**
 *   그림 없는 항목이 조용히 빈 칸으로 뜨는 것을 막으려는 의도적 결합이다.
 */
export const NEW_DOC_GLYPH: Readonly<Record<NewDocKind, FileGlyphName>> = {
  docx: 'word',
  xlsx: 'excel',
  pptx: 'ppt',
  hwpx: 'hwp',
  md: 'markup',
  txt: 'text',
};
